import * as React from 'react';
import { LinkButton } from '@cian/ui-kit';

export interface ICommunicationActionLinkProps {
  href: string;
  children: React.ReactText | React.ReactText[];
  loading?: boolean;
  testId?: string;
  onClick?(): void;
}

export const CommunicationActionLink: React.FC<ICommunicationActionLinkProps> = ({
  testId = 'communication-action',
  ...props
}) => {
  return <LinkButton {...props} data-testid={testId} theme="fill_primary" size="M" fullWidth />;
};

CommunicationActionLink.displayName = 'CommunicationActionLink';
